import * as React from "react";
import { connect } from "react-redux";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LogIn from "../screens/LogIn";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Link from "@mui/material/Link";
import Avatar from "@mui/material/Avatar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core";

import { SidebarData } from "./SidebarData";
import LogoutDropDown from "./LogoutDropDown";
import { useHistory, useLocation } from "react-router";

const useStyles = makeStyles(() => {
  return {
    active: {
      background: "#eaeaea",
    },
    icon: {
      fontSize: "24px",
    },
  };
});

const drawerWidth = 240;

function ResponsiveDrawer(props) {
  const { window } = props;
  const classes = useStyles();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [profilPic, setProfilPic] = React.useState();
  const [openProfile, setOpenProfile] = React.useState(false);

  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {
    requestDataBusiness();
  }, []);

  const requestDataBusiness = async () => {
    try {
      const dataBusiness = await fetch(
        "https://bck-aix-en-provence.carloapp.com/api/business/get_shop_by_id",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Version: "4.0",
            Authorization: `Bearer ${props.token}`,
          },
        }
      );

      const body = await dataBusiness.json();
      setProfilPic(body.data.cover_image_url);
    } catch (error) {
      console.error("Error fetching business data:", error);
      // Set a default profile picture or leave it empty
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClickPath = (item) => {
    history.push(item.path);
    if (item.path === "/") {
      localStorage.clear();
    }
  };

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <Box mt={10}>
        <List>
          {SidebarData.map((item) => (
            <ListItem
              button
              key={item.title}
              onClick={() => handleClickPath(item)}
              className={
                location.pathname === item.path ? classes.active : null
              }
            >
              <ListItemIcon className={classes.icon} sx={{ color: "black" }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ fontSize: "13px", color: "#222629" }}>
                  {item.title}
                </Typography>
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Box>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, height: "73px" }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, marginTop: 1.5, display: { md: "none" } }} // show button to open menu on tablet
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              width: "97vw",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 2,
            }}
          >
            <Link href="/home">
              <Box
                ml={3}
                sx={{ height: 30, width: 101.38 }}
                component="img"
                alt="logo"
                src="carlo_logo_image.png"
              />
            </Link>

            <Avatar
              sx={{ marginRight: 2 }}
              alt="logo merchant"
              src={profilPic}
              onClick={() => setOpenProfile((prev) => !prev)}
            />
            {openProfile && <LogoutDropDown />}
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }} //hide on tablet
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" }, //md : "block" to hide on tablet
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, null)(ResponsiveDrawer);
